import React from "react";
import { BannerProps, TextTransformValue } from "./Banner.types";
import {
  Body5MediumTypography,
  Body5RegularTypography,
} from "../../primitives/Typography/typographyVariants";
import {
  BannerContainer,
  BannerImage,
  BannerContent,
  ArrowIcon,
  BannerTextWrapper,
  CTAContainer,
  BannerDataContainer,
  StyledImageContainer,
} from "./Banner.styles";
import { colorPalette } from "../../theme/colors";
import { ActionButton } from "../ActionButton/ActionButton";

export const Banner: React.FC<BannerProps> = ({
  variant,
  image,
  CTA,
  header,
  subheader,
  arrow,
  icon,
  supportContent,
  bgColor,
  textColor = colorPalette.popBlack[500],
  fontFamily = "Rubik",
  fontWeight = "400",
  lineHeight = "18px",
  letterSpacing = "0.2px",
  textTransform = "none",
  fontSize = "12px",
  onClick,
  centered,
  imageWidth,
  imageHeight,
  dataCy,
}) => {
  const hasCTA = Boolean(CTA); // Check if CTA exists
  const hasArrow = Boolean(arrow); // Check if arrow exists

  return (
    <BannerContainer
      onClick={onClick}
      variant={variant}
      hasCTA={hasCTA}
      hasArrow={hasArrow}
      bgColor={bgColor}
      centered={centered}
      data-cy={dataCy}
    >
      <BannerContent hasCTA={hasCTA}>
        <BannerDataContainer centered={centered}>
          {icon ? (
            <div>{icon}</div> // Display icon if passed
          ) : image ? (
            <StyledImageContainer
              hasCTA={hasCTA}
              width={imageWidth?.toString()}
              height={imageHeight?.toString()}
            >
              <BannerImage
                src={image}
                alt="banner image"
                hasCTA={hasCTA}
                width={imageWidth?.toString()}
                height={imageHeight?.toString()}
              />
            </StyledImageContainer>
          ) : null}
          {hasCTA ? (
            <CTAContainer>
              <BannerTextWrapper
                centered={centered}
                hasGap={Boolean(header && subheader)}
              >
                {header && (
                  <Body5MediumTypography
                    color={textColor || colorPalette.popBlack[500]}
                    textAlign={centered ? "center" : "left"}
                  >
                    {header}
                  </Body5MediumTypography>
                )}

                <Body5RegularTypography
                  color={textColor || colorPalette.popBlack[500]}
                  fontFamily={fontFamily}
                  fontWeight={fontWeight}
                  lineHeight={lineHeight}
                  letterSpacing={letterSpacing}
                  fontSize={fontSize}
                  textTransform={textTransform as TextTransformValue}
                  textAlign={centered ? "center" : "left"}
                >
                  {subheader}
                </Body5RegularTypography>

                {supportContent && <>{supportContent}</>}
              </BannerTextWrapper>
              <ActionButton
                variant="primary"
                onClick={() => {
                  // Handle CTA button click
                }}
              >
                {CTA}
              </ActionButton>
            </CTAContainer>
          ) : (
            <BannerTextWrapper
              hasGap={Boolean(header && subheader)}
              centered={centered}
            >
              {header && (
                <Body5MediumTypography
                  color={textColor || colorPalette.popBlack[500]}
                  textAlign={centered ? "center" : "left"}
                >
                  {header}
                </Body5MediumTypography>
              )}

              <Body5RegularTypography
                color={textColor || colorPalette.popBlack[500]}
                fontFamily={fontFamily}
                fontWeight={fontWeight}
                lineHeight={lineHeight}
                letterSpacing={letterSpacing}
                fontSize={fontSize}
                textTransform={textTransform as TextTransformValue}
                textAlign={centered ? "center" : "left"}
              >
                {subheader}
              </Body5RegularTypography>
              {supportContent && <>{supportContent}</>}
            </BannerTextWrapper>
          )}
        </BannerDataContainer>

        {hasArrow && <ArrowIcon className="fa-kit fa-btn-arrow" />}
      </BannerContent>
    </BannerContainer>
  );
};

export default Banner;
